import { WaterbodyDetail, Waypoint } from '@omniafishing/core';
import React, { useEffect } from 'react';
import { useFrontload } from 'react-frontload';
import { MapQueryParams } from '../../components/map_default/map_default';
import { isProd } from '../../env';
import { useQueryString } from '../../hooks/use_query_string';
import { apiV1 } from '../../lib/api';
import { GlobalQueryParams } from '../../lib/query_string';
import { waitFor } from '../../lib/wait_for';
import { ExtendedMapQueryParams } from './lib/map_page_types';
import MapPage from './map_page';

interface MapPageContainerProps {
  headerHeight: number;
  modalContent?: React.ReactNode;
  modalWaterbody?: WaterbodyDetail;
  seo?: React.ReactNode;
}
const MapPageContainer = (props: MapPageContainerProps) => {
  const { headerHeight, modalContent, seo, modalWaterbody } = props;
  const { getCurrentQuery, replaceQueryString } = useQueryString();
  const currentQuery = getCurrentQuery<ExtendedMapQueryParams>();
  const sharedWaypointQuery = currentQuery[GlobalQueryParams.waypoint_hash];
  const waterbodyQuery = currentQuery.waterbody_slug;
  const externalSearchParam = currentQuery.external_search;

  const { data } = useFrontload('MapPageContainer', async () => {
    let waterbodyLoaded: WaterbodyDetail;
    let sharedWaypointLoaded: Waypoint;

    if (sharedWaypointQuery) {
      try {
        const res = await apiV1.waypointFetch(sharedWaypointQuery);
        sharedWaypointLoaded = res.data.data;
      } catch (e) {
        console.error(e);
      }
    }

    if (waterbodyQuery) {
      try {
        const res = await apiV1.waterbodyFetch(waterbodyQuery);
        waterbodyLoaded = res.data.data;
      } catch (e) {
        console.error(e);
      }
    }

    return {
      waterbody: waterbodyLoaded,
      waypoint: sharedWaypointLoaded,
    };
  });

  const sharedWaypoint = data?.waypoint;
  const waterbody = data?.waterbody;

  useEffect(() => {
    if (sharedWaypoint) {
      replaceQueryString<ExtendedMapQueryParams>({
        [MapQueryParams.lat]: sharedWaypoint.lat,
        [MapQueryParams.lng]: sharedWaypoint.lng,
        [MapQueryParams.zoom]: 12,
      });
    }
  }, [sharedWaypoint?.id_hash]);

  useEffect(() => {
    if (waterbody && !externalSearchParam) {
      replaceQueryString<ExtendedMapQueryParams>({
        [MapQueryParams.lat]: waterbody.lat,
        [MapQueryParams.lng]: waterbody.lng,
        [MapQueryParams.zoom]: 12,
      });
    }
  }, [waterbody?.url_slug]);

  useEffect(() => {
    if (isProd()) {
      waitFor(() => typeof (window as any).AF !== 'undefined', 10_000).then(() => {
        (window as any).AF('banners', 'showBanner');
      });

      return () => {
        if (isProd()) {
          waitFor(() => typeof (window as any).AF !== 'undefined', 10_000).then(() => {
            (window as any).AF('banners', 'hideBanner');
          });
        }
      };
    }
  }, []);

  return (
    <MapPage
      sharedWaypoint={sharedWaypoint}
      waterbody={waterbody}
      headerHeight={headerHeight}
      modalContent={modalContent}
      modalWaterbody={modalWaterbody}
      seo={seo}
    />
  );
};

export default MapPageContainer;
